// Type for the values of PredefinedReasonIds
// export type PredefinedReasonId = typeof PredefinedReasonIds[keyof typeof PredefinedReasonIds];

export const StructuralDefectIds = {
  BUCKLING: "e9f71da8-5dff-4a39-b1d7-7d664e9e4b6b",
  FATIGUE: "9d960430-0bda-422e-97c1-f1f27fd350b8",
  YIELDING: "fca577a7-ffd7-4120-8657-3ac28f6c71fc"
}

export type StructuralDefectId = typeof StructuralDefectIds[keyof typeof StructuralDefectIds];